import { Editor, Range } from "@tiptap/core";
import { Extension } from "@tiptap/core";
import Suggestion from "@tiptap/suggestion";

export interface SuggestionItem {
  title: string;
  description?: string;
  icon?: string;
  command: ({ editor, range }: { editor: Editor; range: Range }) => void;
}

export const Commands = Extension.create({
  name: "slash-commands",

  addOptions() {
    return {
      suggestion: {
        char: "/",
        startOfLine: false,
        command: ({
          editor,
          range,
          props,
        }: {
          editor: Editor;
          range: Range;
          props: any;
        }) => {
          props.command({ editor, range });
        },
      },
    };
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion,
      }),
    ];
  },
});

export const getSuggestionItems = (query: string): SuggestionItem[] => {
  return [
    {
      title: "Snippet",
      description: "Insert a snippet reference",
      icon: "Code2",
      command: ({ editor, range }: { editor: Editor; range: Range }) => {
        editor
          .chain()
          .focus()
          .insertContentAt(range, {
            type: "snippet",
            attrs: {
              mounted: false,
            },
          })
          .run();
      },
    },
    {
      title: "Dataset Examples",
      description: "Insert examples from a dataset",
      icon: "Database",
      command: ({ editor, range }: { editor: Editor; range: Range }) => {
        editor
          .chain()
          .focus()
          .insertContentAt(range, {
            type: "dataset-examples",
            attrs: {
              mounted: false,
            },
          })
          .run();
      },
    },
    {
      title: "Input Variable",
      description: "Insert an input variable",
      icon: "Variable",
      command: ({ editor, range }: { editor: Editor; range: Range }) => {
        editor.chain().focus().deleteRange(range).insertContent("{").run();
      },
    },
    {
      title: "Heading 1",
      description: "Large section heading",
      icon: "Heading1",
      command: ({ editor, range }: { editor: Editor; range: Range }) => {
        editor.chain().focus().deleteRange(range).insertContent("# ").run();
      },
    },
    {
      title: "Heading 2",
      description: "Medium section heading",
      icon: "Heading2",
      command: ({ editor, range }: { editor: Editor; range: Range }) => {
        editor.chain().focus().deleteRange(range).insertContent("## ").run();
      },
    },
    {
      title: "Heading 3",
      description: "Small section heading",
      icon: "Heading3",
      command: ({ editor, range }: { editor: Editor; range: Range }) => {
        editor.chain().focus().deleteRange(range).insertContent("### ").run();
      },
    },
    {
      title: "Heading 4",
      description: "Tiny section heading",
      icon: "Heading4",
      command: ({ editor, range }: { editor: Editor; range: Range }) => {
        editor.chain().focus().deleteRange(range).insertContent("#### ").run();
      },
    },
    {
      title: "Heading 5",
      description: "Smaller section heading",
      icon: "Heading5",
      command: ({ editor, range }: { editor: Editor; range: Range }) => {
        editor.chain().focus().deleteRange(range).insertContent("##### ").run();
      },
    },
    {
      title: "Heading 6",
      description: "Smallest section heading",
      icon: "Heading6",
      command: ({ editor, range }: { editor: Editor; range: Range }) => {
        editor
          .chain()
          .focus()
          .deleteRange(range)
          .insertContent("###### ")
          .run();
      },
    },
  ]
    .filter(
      (item) =>
        item.title.toLowerCase().includes(query.toLowerCase()) ||
        (item.description &&
          item.description.toLowerCase().includes(query.toLowerCase())),
    )
    .slice(0, 10);
};
